<script setup>
/** How far through the year to renewal a policy is (prototype `ring`). Decorative: the words carry it. */
const props = defineProps({
  percent: { type: Number, required: true },
  label: { type: String, required: true },
  soon: { type: Boolean, default: false },
});
const C = 2 * Math.PI * 18;
</script>

<template>
  <span class="cov-ring" :class="{ 'cov-ring--soon': soon }" aria-hidden="true">
    <svg width="44" height="44" viewBox="0 0 44 44">
      <circle cx="22" cy="22" r="18" stroke="currentColor" stroke-opacity=".13" stroke-width="4" fill="none" />
      <circle cx="22" cy="22" r="18" stroke="currentColor" stroke-width="4" fill="none" stroke-linecap="round"
        :stroke-dasharray="C" :stroke-dashoffset="C * (1 - props.percent / 100)" />
    </svg>
    <span class="cov-ring__t">{{ label }}</span>
  </span>
</template>

<style scoped>
.cov-ring { width: 44px; height: 44px; flex: 0 0 44px; position: relative; display: block; color: var(--xl-color-success); }
.cov-ring--soon { color: var(--xl-color-warning); }
.cov-ring svg { transform: rotate(-90deg); display: block; }
.cov-ring__t { position: absolute; inset: 0; display: grid; place-items: center; font-size: 11.5px; font-weight: 700; }
</style>
